import { useExperiment } from 'statsig-react';

const useUserQuiz = () => {
  return useExperiment('d2c_user_quiz').config.get('quiz_active', false);
};

export default useUserQuiz;
